export default "__VITE_ASSET__DUvsgVdP__"